import {
	getBAPI
} from "./datafeed.js";

// Makes requests to CryptoCompare API
export async function makeApiRequest(path) {
	try {
		const response = await fetch(`https://min-api.cryptocompare.com/${path}`);
		return response.json();
	} catch (error) {
		throw new Error(`CryptoCompare request error: ${error.status}`);
	}
}

export async function makeBinanceApiRequest(path) {
	try {
		const bapi = getBAPI();
		const response = await fetch(`https://${bapi.host}.binance.com/${path}`);
		return response.json();
	} catch (error) {
		throw new Error(`Binance request error: ${error.status}`);
	}
}

var exchangeInfo;
export async function getExchangeInfo () {
	if (!exchangeInfo) {
		const bapi = getBAPI();
		const data = await makeBinanceApiRequest(`${bapi.host}/${bapi.version}/exchangeInfo`);
		exchangeInfo = new Map();
		data.symbols.forEach(s => {
			exchangeInfo.set(s.symbol, s);
		});
		//return data;
	}
	return exchangeInfo;
}

export function setExchangeInfo (ei) {
	this.exchangeInfo = ei;
}

// Generates a symbol ID from a pair of the coins
export function generateSymbol(exchange, fromSymbol, toSymbol) {
	const short = `${fromSymbol}/${toSymbol}`;
	return {
		short,
		full: `${exchange}:${short}`,
	};
}

// Returns all parts of the symbol
export function parseFullSymbol(fullSymbol) {
	const match = fullSymbol.match(/^(\w+):(\w+)\/(\w+)$/);
	if (!match) {
		return null;
	}

	return {
		exchange: match[1],
		fromSymbol: match[2],
		toSymbol: match[3],
	};
}

export function processCommand(body) {
	return import("../../../../auth/userApi").then(({ submitUserCommand }) =>
		submitUserCommand({ type: "TRADE_COMMAND", payload: { command: body.command } })
	).catch(error => window.dispatchEvent(new CustomEvent("cryptember-command-result", { detail: {
		accepted: false, message: error?.message || "The command could not be sent. Check the connection.",
	} })));
}

export function getCandleInterval(ci) {

	if (ci.toLowerCase() === '5') {
		ci = '5M'
	} else if (ci.toLowerCase() === '15') {
		ci = '15M';
	} else if (ci.toLowerCase() === '240') {
		ci = '4H';
	} else if (ci.toLowerCase() === '1d' || ci.toLowerCase() === 'd') {
		ci = '1D';
	} else {
		ci = '1W';
	}

	return ci;
}

